import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {PublicPage} from "./public.page";
import {RouteReuseStrategy, RouterModule} from "@angular/router";
import {SharedModule} from "../shared/shared.module";
import {NgxStripeModule, StripeService} from "@nomadreservations/ngx-stripe";
import {OrderComponent} from "./order/order.component";
import {PublicGuard} from "ngx-auth";
import {OrdersService} from "./order/orders.service";
import {PaymentIntentService} from "./order/paymentIntent.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        FontAwesomeModule,
        RouterModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        NgxStripeModule,
    ],
  declarations: [
    PublicPage,
    OrderComponent,

  ],
  exports: [

    PublicPage,
    OrderComponent,
  ],
  providers: [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    PublicGuard,
    OrdersService,
    StripeService,
    PaymentIntentService

  ]


})
export class PublicPageModule { }
